import { Props } from 'react-apexcharts'
import { colors } from '@atlaskit/theme'

import { QueryRunResponse } from 'services/http/bi-tool/query'
import { WidgetVisualization } from 'services/http/bi-tool/widget'

import {
  RadarChartVisualizationNumberFormat,
  RadarChartVisualizationOptions,
} from '../types'
import { numberFormat } from './helpers'

export const mapRadarChartProps = (
  values: QueryRunResponse,
  visualization: WidgetVisualization<RadarChartVisualizationOptions>
): Props => {
  let result: Props = {}
  const label = visualization.options.label
  const value = visualization.options.value

  if (values.rows.length) {
    result = {
      options: {
        chart: {
          animations: {
            enabled: false,
          },
        },
        xaxis: {
          categories: values?.rows
            .filter(
              (row) => row[label?.field] && (row[value?.field] as number) > 0
            )
            .map((row) => row[label?.field] as string),
        },
        dataLabels: {
          enabled: true,
          formatter: (data: number) => {
            return numberFormat(
              data,
              value?.format || ({} as RadarChartVisualizationNumberFormat)
            )
          },
          offsetY: -25,
          style: {
            fontSize: '12px',
            colors: [colors.N600],
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 10,
            dataLabels: {
              position: 'top',
            },
          },
        },
        yaxis: {
          labels: {
            formatter: (data: number) => {
              return numberFormat(
                data,
                value?.format || ({} as RadarChartVisualizationNumberFormat)
              )
            },
          },
        },
        colors: Object.entries(colors)
          .filter(
            (entries) => entries[0].includes('300') && !entries[0].includes('Y')
          )
          .map((entries) => entries[1])
          .slice(0, values.rows.length),
        theme: {
          mode: visualization.theme,
        },
      },
      series: [
        {
          name: value?.alias || value?.field,
          data: values.rows
            .filter((row) => (row[value?.field] as number) > 0)
            .map((row) => row[value?.field]),
        },
      ],
    }
  }

  return result
}
